import styled from "styled-components";

const errorColor = "red";

const FloatingLabel = styled.div`
    font-family: Roboto, sans-serif;
    font-size: 1.1rem;
    line-height: 36px;
    font-weight: 400;
    position: absolute;
    left: 10px;
    transform-origin: left top;
    transition: transform .15s cubic-bezier(.4,0,.2,1),color .15s cubic-bezier(.4,0,.2,1),-webkit-transform .15s cubic-bezier(.4,0,.2,1);
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: text;
    overflow: hidden;
    will-change: transform;
    color: #999;

    &.above {
        cursor: auto;
        transform: translateY(-75%) scale(.75) translateX(-10px);
        color: #ffffff;
        opacity: 0.8;
    }
    &.focused {
        opacity: 1;
    }
    &.error{
        color: ${errorColor};
    }
`;

export default FloatingLabel;


// WEBPACK FOOTER //
// ./src/SharedComponents/FloatingLabel.tsx